export default {"src":"/_next/static/media/sorcery.8de33a61.svg","height":758,"width":600,"blurWidth":0,"blurHeight":0};